/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Create_TitleInputs */

const en_admin_invite_codes_create_title = /** @type {(inputs: Admin_Invite_Codes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Invite Codes`)
};

const zh_admin_invite_codes_create_title = /** @type {(inputs: Admin_Invite_Codes_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建邀请码`)
};

/**
* | output |
* | --- |
* | "Create Invite Codes" |
*
* @param {Admin_Invite_Codes_Create_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_create_title = /** @type {((inputs?: Admin_Invite_Codes_Create_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Create_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_create_title(inputs)
	return zh_admin_invite_codes_create_title(inputs)
});
export { admin_invite_codes_create_title as "admin.invite_codes.create_title" }